// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.k-form .dataCaptureSection .addAddressHistory {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 68px;
  padding-top: 32px;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 15px;
  width: 100%;
  text-align: left;
}
.k-form .dataCaptureSection .addAddressHistory > section {
  width: 100%;
}
.k-form .dataCaptureSection .addAddressHistory .addButton,
.k-form .dataCaptureSection .addAddressHistory p {
  display: inline-block;
  vertical-align: middle;
}
.k-form .dataCaptureSection .addAddressHistory .error.normalText {
  font-size: 15px;
  color: #c23a00;
}
.k-form .dataCaptureSection .addAddressHistory .bp3-popover-wrapper {
  padding: 0;
}
.k-form .dataCaptureSection .addAddressHistory .bp3-popover-wrapper div {
  padding: 0;
}
.k-form .dataCaptureSection .addAddressHistory > .error {
  top: -12px;
}
.k-form .dataCaptureSection .sectionContainer .alignRight {
  float: right;
}
.k-form .dataCaptureSection .sectionContainer.addAddressHistory.expanded {
  padding-left: 17px;
  padding-right: 17px;
  height: auto;
}
.k-form .dataCaptureSection .currentAddress {
  border: unset !important;
}
.k-form .dataCaptureSection .k-form-field.addressLookupField .autocompleteDropdownContainer {
  width: calc(100% - 66px);
  flex-grow: 2;
}
.k-form .dataCaptureSection .k-form-field.addressLookupField .autocompleteDropdownContainer .suggestionItem {
  text-align: left;
}
@media (max-width: 845px) {
  .k-form .dataCaptureSection .sectionContainer.addAddressHistory .addButton {
    order: 2;
    margin: 16px 0 0 0;
    display: block;
  }
  .k-form .dataCaptureSection .sectionContainer.addAddressHistory p {
    order: 1;
    width: 100%;
    text-align: left;
    padding-left: 0;
  }
  .k-form .dataCaptureSection .sectionContainer.addAddressHistory.expanded {
    padding-left: 0;
    padding-right: 0;
  }
  .k-form .dataCaptureSection .k-form-field.addressLookupField .autocompleteDropdownContainer {
    width: 286px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/AddressHistoryEditor.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EAEE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAWF;AAtBA;EAeG,WAAA;AAUH;AAzBA;;EAoBG,qBAAA;EACA,sBAAA;AASH;AA9BA;EAwBG,eAAA;EACA,cAAA;AASH;AAlCA;EA4BG,UAAA;AASH;AArCA;EA8BI,UAAA;AAUJ;AANE;EACC,UAAA;AAQH;AA3CA;EAyCG,YAAA;AAKH;AA9CA;EA8CE,kBAAA;EACA,mBAAA;EACA,YAAA;AAGF;AAnDA;EAoDE,wBAAA;AAEF;AAtDA;EAwDE,wBAAA;EACA,YAAA;AACF;AA1DA;EA2DG,gBAAA;AAEH;AAEC;EAAA;IAGG,QAAA;IACA,kBAAA;IACA,cAAA;EADF;EAJD;IASG,QAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;EAFF;EAKC;IACC,eAAA;IACA,gBAAA;EAHF;EAdD;IAsBE,YAAA;EALD;AACF","sourcesContent":["@import '../../constants.less';\n\n.k-form .dataCaptureSection {\n\t.addAddressHistory {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t\tmin-height: 68px;\n\t\tpadding-top: 32px;\n\t\tpadding-left: 32px;\n\t\tpadding-right: 32px;\n\t\tfont-size: 15px;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\n\t\t// this is a hack to handle the generic nature of Dynamic forms, and the Address Histories flexbox implementation\n\t\t> section {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.addButton,\n\t\tp {\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t}\n\t\t.error.normalText {\n\t\t\tfont-size: 15px;\n\t\t\tcolor: @errorMessageColor;\n\t\t}\n\t\t.bp3-popover-wrapper {\n\t\t\tpadding: 0;\n\t\t\tdiv {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\n\t\t& > .error {\n\t\t\ttop: -12px;\n\t\t}\n\t}\n\n\t.sectionContainer {\n\t\t.alignRight {\n\t\t\tfloat: right;\n\t\t}\n\t}\n\n\t.sectionContainer.addAddressHistory.expanded {\n\t\tpadding-left: @dataCaptureContainerPadding;\n\t\tpadding-right: @dataCaptureContainerPadding;\n\t\theight: auto;\n\t}\n\n\t.currentAddress {\n\t\tborder: unset !important;\n\t}\n\n\t.k-form-field.addressLookupField .autocompleteDropdownContainer {\n\t\twidth: calc(100% - 66px);\n\t\tflex-grow: 2;\n\t\t.suggestionItem {\n\t\t\ttext-align: left;\n\t\t}\n\t}\n\n\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t.sectionContainer.addAddressHistory {\n\t\t\t.addButton {\n\t\t\t\torder: 2;\n\t\t\t\tmargin: 16px 0 0 0;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\torder: 1;\n\t\t\t\twidth: 100%;\n\t\t\t\ttext-align: left;\n\t\t\t\tpadding-left: 0;\n\t\t\t}\n\n\t\t\t&.expanded {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tpadding-right: 0;\n\t\t\t}\n\t\t}\n\n\t\t.k-form-field.addressLookupField .autocompleteDropdownContainer {\n\t\t\twidth: 286px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
